export default __webpack_public_path__ + "static/media/coresanscr45it-webfont.ae6f1ced.woff";